import { createAction, createAsyncAction } from 'typesafe-actions';
import { MODULE } from './constants';
import {
  FXRollsGenerateRequestPayload,
  FXRollsGenerateResponse,
  FXRollValueDatesRequestPayload,
  FXRollValueDatesResponse,
  FXRollsListRequestPayload,
  FXRollsListResponse,
  FXRollsDeleteRequestPayload,
  FXRollsDeleteResponse,
  FXRollsSubmitRequestPayload,
  FXRollsSubmitResponse,
  FXRollGroupingRulesResponse,
} from './types';



export const generateFxRolls = createAsyncAction(
  `${MODULE}/generateFxRolls/request`,
  `${MODULE}/generateFxRolls/success`,
  `${MODULE}/generateFxRolls/failure`,
)<
  FXRollsGenerateRequestPayload,
  { data: FXRollsGenerateResponse },
  { error: string }
>();

export const resetGenerateFxRolls = createAction(
  `${MODULE}/generateFxRolls/reset`,
)();



export const fetchFxRollValueDates = createAsyncAction(
  `${MODULE}/fetchFxRollValueDates/request`,
  `${MODULE}/fetchFxRollValueDates/success`,
  `${MODULE}/fetchFxRollValueDates/failure`,
)<
  FXRollValueDatesRequestPayload,
  { data: FXRollValueDatesResponse },
  { error: string }
>();

export const resetFxRollValueDates = createAction(
  `${MODULE}/fetchFxRollValueDates/reset`,
)();

export const listFxRolls = createAsyncAction(
  `${MODULE}/listFxRolls/request`,
  `${MODULE}/listFxRolls/success`,
  `${MODULE}/listFxRolls/failure`,
)<
  FXRollsListRequestPayload,
  { data: FXRollsListResponse },
  { error: string }
>();

export const resetListFxRolls = createAction(
  `${MODULE}/listFxRolls/reset`,
)();

export const deleteFxRolls = createAsyncAction(
  `${MODULE}/deleteFxRolls/request`,
  `${MODULE}/deleteFxRolls/success`,
  `${MODULE}/deleteFxRolls/failure`,
)<
  FXRollsDeleteRequestPayload,
  { data: FXRollsDeleteResponse },
  { error: string }
>();

export const resetDeleteFxRolls = createAction(
  `${MODULE}/deleteFxRolls/reset`,
)();

export const submitFxRolls = createAsyncAction(
  `${MODULE}/submitFxRolls/request`,
  `${MODULE}/submitFxRolls/success`,
  `${MODULE}/submitFxRolls/failure`,
)<
  FXRollsSubmitRequestPayload,
  { data: FXRollsSubmitResponse },
  { error: string }
>();

export const resetSubmitFxRolls = createAction(
  `${MODULE}/submitFxRolls/reset`,
)();

export const fetchGroupingRules = createAsyncAction(
  `${MODULE}/fetchGroupingRules/request`,
  `${MODULE}/fetchGroupingRules/success`,
  `${MODULE}/fetchGroupingRules/failure`,
)<
  void,
  { data: FXRollGroupingRulesResponse },
  { error: string }
>();

export const resetGroupingRules = createAction(
  `${MODULE}/fetchGroupingRules/reset`,
)();
